import { I18nComponente } from "@/types/gerais"

export const OSeletorSemanali18n: I18nComponente = {
  "pt-BR": {
    listaDeDiasDaSemana: {
      domingo: {
        rotulo: "D",
        nome: "Domingo",
      },
      segunda: {
        rotulo: "S",
        nome: "Segunda",
      },
      terca: {
        rotulo: "T",
        nome: "Terça",
      },
      quarta: {
        rotulo: "Q",
        nome: "Quarta",
      },
      quinta: {
        rotulo: "Q",
        nome: "Quinta",
      },
      sexta: {
        rotulo: "S",
        nome: "Sexta",
      },
      sabado: {
        rotulo: "S",
        nome: "Sábado",
      },
    },
  },
  "es-CO": {
    listaDeDiasDaSemana: {
      domingo: {
        rotulo: "D",
        nome: "Domingo",
      },
      segunda: {
        rotulo: "L",
        nome: "Lunes",
      },
      terca: {
        rotulo: "M",
        nome: "Martes",
      },
      quarta: {
        rotulo: "M",
        nome: "Miércoles",
      },
      quinta: {
        rotulo: "J",
        nome: "Jueves",
      },
      sexta: {
        rotulo: "V",
        nome: "Viernes",
      },
      sabado: {
        rotulo: "S",
        nome: "Sábado",
      },
    },
  },
}
